import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking, AppInsightsContext } from '@microsoft/applicationinsights-react-js';

let reactPlugin = new ReactPlugin();
let appInsights = new ApplicationInsights({
	config: {
		connectionString: process.env.NEXT_PUBLIC_AZURE_APP_INSIGHTS_KEY,
		disableAjaxTracking: false,
		disableCookiesUsage: true,
		disableDbgExt: true,
		disableExceptionTracking: false,
		disableFetchTracking: false,
		disableTelemetry: false,
		loggingLevelTelemetry: 0,
		extensions: [reactPlugin as any],
		disablePageUnloadEvents: ['unload'],
		enableAutoRouteTracking: true,
		enableCorsCorrelation: true,
		enableRequestHeaderTracking: true,
		disableCorrelationHeaders: false,
		enableResponseHeaderTracking: true,
		distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
	},
});

if (process.env.NODE_ENV.toLowerCase() === 'production') {
	appInsights.loadAppInsights();
	appInsights.trackPageView();
}

const AzureAppInsights = ({ children }: { children: any }) => {
	return <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>;
};

export default withAITracking(reactPlugin, AzureAppInsights);
